const Connect = require("react-redux").connect;
const CroquisActions = require("actions/croquis");
const RenderTest = require("../components/RenderTest");

const internals = {};

internals.connect = Connect(
    state => ({
        token: state.auth.credentials.token,
        list: state.croquis.testerData
    }),
    {
        fetchData: CroquisActions.fetchTesterData
    }
);

module.exports = internals.connect(RenderTest);



// WEBPACK FOOTER //
// ./src/routes/render-test/containers/RenderTest.js